
<template>
  <div>
    <v-row>
      <v-col class="font-weight-bold subtitle-1 pb-0" cols='2'>#</v-col>
      <!-- <v-col class="font-weight-bold subtitle-1 pb-0" cols='2'>{{trace_type_map[trace.traceable_type.toLowerCase()]}}</v-col> -->
      <v-col class="font-weight-bold subtitle-1 pb-0" cols='4'>Descrição</v-col>
      <v-col class="font-weight-bold subtitle-1 pb-0">Valor</v-col>
      <v-col class="font-weight-bold subtitle-1 pb-0">Pago em:</v-col>
      <v-col class="font-weight-bold subtitle-1 pb-0"></v-col>

    </v-row>

    <!-- <div>{{list_of}}</div> -->
    <v-row v-for="(trace, idx) in traces" :key="trace.id" align='center' >
      <v-col cols='2'>
        #{{trace.id}}
      </v-col>
      <!-- <v-col cols='2'>{{trace_type_map[trace.traceable_type.toLowerCase()]}}</v-col> -->
      
      <v-col cols='4' v-if="hf.type=='vrt_transaction'">
        {{trace_type_map[trace.traceable_type.toLowerCase()]}} - 
        <span v-if="trace.traceable_solution">
          {{solution_map[trace.traceable_solution.solution]}}
        </span>
      </v-col>
      <v-col cols='4' v-if="hf.type!='vrt_transaction'">
        Fatura - 
        {{solution_map[trace.vrt_solution]}}
        <!-- #{{trace.vrt_transaction_id}}  -->
        <span v-if="trace.order_id">
          {{`(Pedido #${trace.order_id}, ${trace.total_order_bags} sacos ${trace.brand_name}, ${$moment(trace.loaded.substring(0,10)+'T12:00:00').format('l')})`}}
          <v-btn icon small color="primary" @click="openOrderInNewTab(trace.order_id, 'wholesale')"><v-icon small>mdi-open-in-new</v-icon></v-btn>
        </span>
        <span v-if="trace.external_order_id">
          {{`(Pedido externo: #${trace.external_order_id})`}}
          <v-btn icon small color="primary" @click="openOrderInNewTab(trace.external_order_id, 'retail')"><v-icon small>mdi-open-in-new</v-icon></v-btn>
        </span>
      </v-col>
      
      <v-col>{{Number(trace.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</v-col>
      <v-col>{{$moment(trace.created_at.substring(0,10)+'T12:00:00').format('l')}}</v-col>
      
      <v-col v-if="!trace.to_bonus">
        <v-btn small color="primary" @click="seeDetails(trace)" outlined rounded>
          <v-icon left small>mdi-plus</v-icon> 
          detalhes
        </v-btn>
      </v-col>
      <v-col v-if="trace.to_bonus">
        <v-chip> Bônus </v-chip>
      </v-col>
      <v-col cols="12" v-if="traces.length > (idx + 1) " class="pa-0">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'

export default {
  name: "ListItemTrace",
  mixins: [SolutionMap],
  props: {
    traces: {
      type: Array,
    },
    hf: {
      type: Object,
    },
    list_of:{
      type: String,
      default: 'vrt_transaction' // [vrt_transaction, payments]
    },
    last_item:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: null,
      trace_type_map:{
        vrt_transaction: "Fatura",
        deposit: "Depósito",
        check: "Cheque",
        cash: "Dinheiro",
        pay_devolution: 'Devolução',
        bill: "Boleto",
        pix: "PIX",
        clientcredit: "Crédito/Bônus do cliente",
        exchange: "Permuta",
      },
      URL_MAP: {
        'wholesale' : { 
          label: 'Grandes cargas',
          icon: 'mdi-store-settings',
          color: '#E53935',
          kind: 'wholesale',
          link: '',
          development_link: 'http://localhost:3000/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        'retail' :{ 
          label: 'Galpão',
          icon: 'mdi-cart',
          color: '#E53935',
          kind: 'retail',
          link: '',
          development_link: 'http://localhost:8080/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
      }
    }
  },
  methods: {
    openOrderInNewTab(order_id, solution){
      this.URL_MAP[solution].function(`${this.URL_MAP[solution].link}/${order_id}`)
    },
    seeDetails(trace) {
      let item = {}
      if (this.list_of=='payment'){
        if (trace.vrt_transaction_id){
          item.type = 'vrt_transaction'
          item.kind = 'vrt_transaction'
          item.id = trace.vrt_transaction_id
        } 
      } else if (this.list_of == 'vrt_transaction'){
        if (true) {
          item.type = 'payment'
          item.kind = trace.traceable_type.split(/(?=[A-Z])/).join('_').toLowerCase()
          item.id = trace.traceable_id
          item.vrt_transaction_id = trace.vrt_transaction_id
          item.to_bonus = trace.to_bonus
        }
      }
      this.$emit('detailsClick', {...item})
    },
    setLinks(){
      let wholesale = {
        production_link: 'https://webcimentao.com.br/concluded/order',
        development_link: 'http://localhost:3000/concluded/order',
        qa_link: 'https://grandes_cargas_qa2.webcimentao.com.br/concluded/order',
      }
      let retail = {
        production_link: 'https://galpoes.webcimentao.com.br/order',
        development_link: 'http://localhost:8080/order',
        qa_link: 'https://galpoes-qa.webcimentao.com.br/order',
      }

      if(process.env.NODE_ENV == 'qa'){
        this.URL_MAP['wholesale'].link = wholesale.qa_link
        this.URL_MAP['retail'].link = retail.qa_link
      }else if(process.env.NODE_ENV == 'production'){
        this.URL_MAP['wholesale'].link = wholesale.production_link
        this.URL_MAP['retail'].link = retail.production_link
      }else if(process.env.NODE_ENV == 'development' ){
        this.URL_MAP['wholesale'].link = wholesale.development_link
        this.URL_MAP['retail'].link = retail.development_link
      }

    },
  },
  computed: {
  },
  mounted(){
    this.setLinks()
  }
}
</script>